"use strict";
module.exports = [
    {
        "id": "0x09305998a531fade369ebe30adf868c96a34e813",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://pm_dreamverse_eminence",
        "symbol": "DCLPMDRMVRSMNNC"
    },
    {
        "id": "0x0b1c6c75d511fae05e7dc696f4cf14129a9c43c9",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://ml_liondance",
        "symbol": "DCLLMLNDNC"
    },
    {
        "id": "0x102daabd1e9d294d4436ec4c521dce7b1f15499e",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dc_niftyblocksmith",
        "symbol": "DCLDCNFTYBLCKSMTH"
    },
    {
        "id": "0x1a57f6afc902d25792c53b8f19b7e17ef84222d5",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://meme_dontbuythis",
        "symbol": "DCLMMDNTBYTHS"
    },
    {
        "id": "0x1e1d4e6262787c8a8783a37fee698bd42aa42bec",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dappcraft_moonminer",
        "symbol": "DCLDPPCRFTMNMNR"
    },
    {
        "id": "0x201c3af8c471e5842428b74d1e7c0249adda2a92",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://stay_safe",
        "symbol": "DCLSTYSF"
    },
    {
        "id": "0x24d538a6265b006d4b53c45ba91af5ef60dca6cb",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://cybermike_cybersoldier_set",
        "symbol": "DCLCYBMKCYBRSLDRST"
    },
    {
        "id": "0x30d3387ff3de2a21bef7032f82d00ff7739e403c",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://mf_sammichgamer",
        "symbol": "DCLMFSMMCHGMR"
    },
    {
        "id": "0x3163d2cfee3183f9874e2869942cc62649eeb004",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dcg_collection",
        "symbol": "DCLDCGCLLCTN"
    },
    {
        "id": "0x32b7495895264ac9d0b12d32afd435453458b1c6",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://community_contest",
        "symbol": "DCLCMMNTCNTST"
    },
    {
        "id": "0x34ed0aa248f60f54dd32fbc9883d6137a491f4f3",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://wonderzone_meteorchaser",
        "symbol": "DCLWNDRZNMTRCHSR"
    },
    {
        "id": "0x480a0f4e360e8964e68858dd231c2922f1df45ef",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://tech_tribal_marc0matic",
        "symbol": "DCLTCHTRBLMRC0MTC"
    },
    {
        "id": "0x4c290f486bae507719c562b6b524bdb71a2570c9",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://atari_launch",
        "symbol": "DCLTR"
    },
    {
        "id": "0x54266bcf2ffa841af934f003d144957d5934f3ab",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://ethermon_wearables",
        "symbol": "DCLETHRMNWRBL"
    },
    {
        "id": "0x574f64ac2e7215cba9752b85fc73030f35166bc0",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dgtble_headspace",
        "symbol": "DCLDGTBLHDSPC"
    },
    {
        "id": "0x5cf39e64392c615fd8086838883958752a11b486",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://digital_alchemy",
        "symbol": "DCLDGTLLCHMY"
    },
    {
        "id": "0x5df4602e7f38a91ea7724fc167f0c67f61604b1e",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://wz_wonderbot",
        "symbol": "DCLWZWNDRBT"
    },
    {
        "id": "0x60d8271c501501c4b8cd9ed5343ac59d1b79d993",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://ml_pekingopera",
        "symbol": "DCLMLPKNGPR"
    },
    {
        "id": "0x68e139552c4077ce5c9ab929c7e18ca721ffff00",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://rac_basics",
        "symbol": "DCLRCBSCS"
    },
    {
        "id": "0x6a99abebb48819d2abe92c5e4dc4f48dc09a3ee8",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://moonshot_2020",
        "symbol": "DCLMNSHT2020"
    },
    {
        "id": "0x6b47e7066c7db71aa04a1d5872496fe05c4c331f",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://rtfkt_x_atari",
        "symbol": "DCLRTFTKTI"
    },
    {
        "id": "0x7038e9d2c6f5f84469a84cf9bc5f4909bb6ac5e0",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dg_fall_2020",
        "symbol": "DCLDGFLL2020"
    },
    {
        "id": "0x75a3752579dc2d63ca229eebbe3537fbabf85a12",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://pm_outtathisworld",
        "symbol": "DCLPMTTTHSWRLD"
    },
    {
        "id": "0x90958d4531258ca11d18396d4174a007edbc2b42",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://china_flying",
        "symbol": "DCLCHNFLYNG"
    },
    {
        "id": "0xa8ee490e4c4da48cc1653502c1a77479d4d818de",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://binance_us_collection",
        "symbol": "DCLBNNCSCLLCTN"
    },
    {
        "id": "0xb5d14052d1e2bce2a2d7459d0379256e632b855d",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://sugarclub_yumi",
        "symbol": "DCLSGRCLBYM"
    },
    {
        "id": "0xb96697fa4a3361ba35b774a42c58daccaad1b8e1",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://wonderzone_steampunk",
        "symbol": "DCLWNDRZNSTMPNK"
    },
    {
        "id": "0xbf53c33235cbfc22cef5a61a83484b86342679c5",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dg_summer_2020",
        "symbol": "DCLDGSMMR2020"
    },
    {
        "id": "0xc04528c14c8ffd84c7c1fb6719b4a89853035cdd",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://exclusive_masks",
        "symbol": "DCLEXCLSVMSKS"
    },
    {
        "id": "0xc1f4b0eea2bd6690930e6c66efd3e197d620b9c2",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://halloween_2019",
        "symbol": "DCLHLWN2019"
    },
    {
        "id": "0xc3af02c0fd486c8e9da5788b915d6fff3f049866",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://xmas_2019",
        "symbol": "DCLXMAS2019"
    },
    {
        "id": "0xc3ca6c364b854fd0a653a43f8344f8c22ddfdd26",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://cz_mercenary_mtz",
        "symbol": "DCLCZMRCNRYMTZ"
    },
    {
        "id": "0xc82a864a94db3550bc71fcb4ce07228bcec21f1a",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://winklevoss_capital",
        "symbol": "DCLWNKLVSSCPTL"
    },
    {
        "id": "0xd35147be6401dcb20811f2104c33de8e97ed6818",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dcl_launch",
        "symbol": "DCLLNCH"
    },
    {
        "id": "0xdd9c7bc159dacb19c9f6b9d7e23948c87aa2397f",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://xmash_up_2020",
        "symbol": "DCLXMSHP2020"
    },
    {
        "id": "0xe1ecb4e5130f493551c7d6df96ad19e5b431a0a9",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://3lau_basics",
        "symbol": "DCL3LBSCS"
    },
    {
        "id": "0xe7a64f6a239ed7f5bf18caa1ce2920d0c1278129",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://dc_meta",
        "symbol": "DCLDCMT"
    },
    {
        "id": "0xecf073f91101ce5628669c487aee8f5822a101b1",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://xmas_2020",
        "symbol": "DCLXMAS2020"
    },
    {
        "id": "0xf64dc33a192e056bb5f0e5049356a0498b502d50",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://mch_collection",
        "symbol": "DCLMCHCLLTN"
    },
    {
        "id": "0xfeb52cbf71b9adac957c6f948a6cf9980ac8c907",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://halloween_2020",
        "symbol": "DCLHLWN2020"
    },
    {
        "id": "0xffc5043d9a00865d089d5eefa5b3d1625aec6763",
        "isApproved": null,
        "isCompleted": true,
        "name": "dcl://release_the_kraken",
        "symbol": "DCLRLSTHKRKN"
    }
];
//# sourceMappingURL=collections-v1.js.map